import { render, staticRenderFns } from "./KBIcon.vue?vue&type=template&id=1b79b846&"
import script from "./KBIcon.vue?vue&type=script&lang=js&"
export * from "./KBIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports